module.exports = __webpack_public_path__ + "static/media/waves.11fa5f73.png";